import React, { useState } from 'react';
import { ICreateProfile } from '../../../../@types/profile';
import { getProfile, updateProfile } from '../../../../backend-services';
import { EditProfile } from './EditForm';
import toast from 'react-hot-toast';



interface CreateEditProfileProps {
  onCreateEditProfile?: (profile: ICreateProfile) => void;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  show: boolean;
  onClose?: () => void;
 
}

const CreateEditProfile = ({ onCreateEditProfile, show, onClose }: CreateEditProfileProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [, setErrorMessage] = React.useState('');
  const [formData, setFormData] = useState({
   firstName: '',
    lastName: '',
    businessName: ' ',
    email: '',
    phone: '',
    industry: '',
    address: '',
    state:'',
    city:'',
    businessSize: '',
    brandLogo:'',
    brandColor:'',

   });

  const handleEditProfile = async (profile: ICreateProfile) => {
    setIsLoading(true);
     try {
       
        const data = await updateProfile({
            firstName: profile.firstName,
            lastName: profile.lastName,
            businessName: profile.businessName,
            phone: profile.phone,
            industry: profile.industry,
            address: profile.address,
            state: profile.state,
            city: profile.city,
            businessSize:profile.businessSize,
            brandLogo:profile.brandLogo,
            brandColor:profile.brandColor,
         
        });
    
        setIsLoading(false);
        setIsOpen(false);
        toast.success('Profile Changes saved');
        onCreateEditProfile && onCreateEditProfile(data);
        onClose && onClose();
      } catch (e) {
        setErrorMessage('Unable to update profile.');
        setIsLoading(false);
      }
    };


    const getProfileHandler = async () => {
      setIsLoading(true);
      try {
        const data = await getProfile();
        console.log(data)
        setIsLoading(false);
        setFormData(data);
      } catch (e) {
        setIsLoading(false);
        toast.error('Failed to load profile');
      }
    };
    React.useEffect(() => {
      getProfileHandler();
    }, []);
    
  const handleClose = () => {
    setIsOpen(false);
    onClose && onClose();
  };

  React.useEffect(() => {
    setIsOpen(show);
  }, [show]);
  

  

  return isOpen ? (
    <>
      {/* Modal Background */}
      <div
        aria-hidden="false"
        className="relative top-0 right-0 left-0 z-50 h-[200vh]  overflow-y-auto  overflow-x-hidden items-start flex bg-gray-900 bg-opacity-50 "
      >
        <div>

          {/* MODAL BODY */}
          <div className="xl:p-4 pt-10 ">
            <EditProfile
              isLoading={isLoading}
              show={true}
              onSubmit={handleEditProfile}
              onClose={handleClose}
              data={formData}
            />
          </div>
        </div>
      </div>
    </>
  ) : null;
};

export { CreateEditProfile}